/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Load_TranslationInputs */



/**
* | output |
* | --- |
* | "Failed to load translation" |
*
* @param {Failed_To_Load_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_load_translation = /** @type {((inputs?: Failed_To_Load_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Load_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du chargement de la traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung konnte nicht geladen werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare la traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить перевод")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar la traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译加载失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳を読み込めませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद लोड करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao carregar a tradução")
	return /** @type {LocalizedString} */ ("Failed to load translation")
});